import { Formik } from 'formik';
import { FC } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import {
  SocialInput,
  InputLength,
  SocialPlatform,
  FormType,
  OutputQuantity,
} from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import { ToneInputs } from '../formInputs/ToneInputs';

import formStyles from '../formStyles.module.css';
import { IntentInput } from '../formInputs/IntentInput';
import { CompanyNameWebsiteInputs } from '../formInputs/CompanyNameWebsiteInputs';
import { TargetDemographicInputs } from '../formInputs/TargetDemographicInputs';
import { SocialPlatformInputs } from '../formInputs/PlatformInputs';
import { AdvancedInputs } from '../formInputs/AdvancedInputs';
import { useRouter } from 'next/router';
import { ToggleInput } from '../../../../shared/inputs/ToggleInput';
import styles from './PersonaSocialStyle.module.css';
import { SmallerSimpleBadge } from '../../../../shared/badge/SmallerSimpleBadge';
const EGInputsSchema = yup.object<
  Partial<Record<keyof SocialInput, yup.AnySchema>>
>({
  platform: yup
    .mixed<SocialPlatform>()
    .oneOf(Object.values(SocialPlatform))
    .required('Please select platform'),
  companyName: yup.string().required("Please add your company's name"),
  companyWebsite: yup.string().notRequired(),
  intent: yup
    .string()
    .required('Please enter the intent of your social post')
    .min(5, 'Intent is too vague! Consider adding more details'),
  topics: yup.array().of(yup.string()).min(0, ''),
  tone: yup
    .array()
    .of(yup.string())
    .min(1, 'Please select at least 1 tone for your social post'),
  toneDegree: yup.object(),
  targetDemographic: yup
    .array()
    .of(yup.string())
    .min(1, 'Please select at least 1 target demographic for your social post'),
  length: yup
    .mixed<InputLength>()
    .oneOf(Object.values(InputLength))
    .required('Please select a length for your social post'),
  multipleOutputs: yup
    .mixed<OutputQuantity>()
    .oneOf(Object.values(OutputQuantity))
    .required(),
});

export const SocialForm: FC = () => {
  const {
    socialInput,
    setSocialInput,
    submitContentForm,
    setCanKeepGoing,
    loading,
  } = useFormContext();
  const router = useRouter();

  // Inputs may need to be prefilled
  if (!socialInput) return null;

  return (
    <Formik
      initialValues={socialInput}
      onSubmit={async (values, actions) => {
        await submitContentForm({ values, actions, formType: FormType.SOCIAL });
      }}
      validationSchema={EGInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setSocialInput(values as SocialInput);
                setCanKeepGoing(false);
              }}
            />
              <div className={styles['toggle']}>
                  <ToggleInput
                  id='manualToggle'
                  disabled={false}
                  isChecked={false}
                  onClick={() => {
                    history.back()
                  }} 
                  />
                  <div className={styles['toggle-name']}>
                  <b>Persona Mode</b>
                  </div>
                </div>
            <div className={styles['create-button2']}>
              <SocialPlatformInputs formikProps={props} disabled={loading} />
            </div>
            <div>
              <CompanyNameWebsiteInputs
                formikProps={props}
                disabled={loading}
              />
            </div>
            <div>
              <IntentInput formikProps={props} disabled={loading} />
            </div>
            <div>
              <ToneInputs formikProps={props} disabled={loading} />
            </div>
            <div>
              <TargetDemographicInputs formikProps={props} disabled={loading} />
            </div>
            <div>
              <AdvancedInputs formikProps={props} disabled={loading} />
            </div>
            {/* <div>
            <BasicButtonSelectionInput
              id="length"
              label={
                <div>
                  <h2>What is the length of the social post?</h2>
                </div>
              }
              defaultOptions={Object.values(InputLength)}
              value={props.values.length}
              setValue={props.handleChange("length")}
              disabled={loading}
              errors={props.errors.length}
              touched={props.touched.length}
              onBlur={props.handleBlur}
            />
          </div> */}
          </div>
          <GenerateResponseButtons onSubmit={() => props.handleSubmit()} />
        </>
      )}
    </Formik>
  );
};
